module.exports = __webpack_public_path__ + "img/gillete.1d3980d4.png";